import { _getConfigForFetchUserEnvironment } from '#/config/appConfigUtils';
import type { AppConfig } from '#/config/types/AppConfig';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiUserEnvironment } from './types/ApiUserEnvironment';

type ApiResponse = ApiUserEnvironment & {
  config: AppConfig;
};

function mapResponse(response: ApiResponse) {
  return {
    user: response.user,
    environment: response.environment,
    appConfig: HORIZON_ENABLED
      ? response.config
      : _getConfigForFetchUserEnvironment(),
  };
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/data/environment',
  mapResponse,
});

// Exports

export const apiGetFetchUserEnvironmentSsrApiData =
  endpoint.createSsrApiDataFn();

export const apiFetchUserEnvironment = endpoint.createClientFetchFn();

export const apiIsomorphicFetchUserEnvironment =
  endpoint.createIsomorphicFetchFn();
